import React from "react";
import { LinkButton } from "../../../../../components/Buttons/LinkButton";
import { DeleteButton } from "../styled";

/**
 * ArrayRemoveButton component for removing items from a Formik FieldArray.
 * @param {Object} props
 * @param {Object} props.arrayHelpers - Formik FieldArray helpers.
 * @param {Array} props.dataArray - The current array of items.
 * @param {number} props.itemIndex - Index of the item to remove.
 * @param {string} props.prospectPath - Path in the prospect object.
 * @param {Function} props.updateRoProspect - Function to update the prospect.
 */
export const ArrayRemoveButton = ({
  arrayHelpers,
  dataArray,
  itemIndex,
  prospectPath,
  updateRoProspect,
  ...props
}) => {
  return (
    <DeleteButton>
      <LinkButton
        clickHandler={() => {
          if (itemIndex > -1) {
            arrayHelpers.remove(itemIndex);
            const removedArray = [...dataArray];
            removedArray.splice(itemIndex, 1);
            updateRoProspect({
              [prospectPath]: removedArray
            });
          }
        }}
        title="Delete"
        data-testid="array-remove-button"
        {...props}
      />
    </DeleteButton>
  );
};
